import { render } from "./FieldsetSkeleton.vue?vue&type=template&id=8b9b2a76"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__